import { P2GGrid } from '@parcel2go/core-ui';
import { useState } from 'react';
import { SmartSendItemApiModel, UpdateManifestApiModel } from '~/lib/api/smartsend/types';
import { P2GLink } from '@parcel2go/core-ui';
import DropConfirm from './DropConfirm';
import { IsPreManifest } from '../../../lib/helpers/IsPreManifest';
import { Consts, ManifestRefreshType } from '../../../lib/em/EmitTypes';
import { useEventEmitter } from '../../../lib/em/Hooks';
import { ExtendedOrderCache } from '../../../lib/cache/ExtendedOrderCache';
import P2GContentDropDown from '../../P2GContentDropDown';
import AlertWithIcon from '../../AlertWithIcon';
import { P2GText } from '@parcel2go/core-ui';
import { useSmartSendApi } from '~/lib/api/smartsend/use-smartsend-api';

interface props {
  item: SmartSendItemApiModel;
}

type state = 'IDLE' | 'CANCELLING' | 'ERROR' | 'SUCCESS';

export default function CancelLabelsPreManifest(props: props) {
  const { updateManifest } = useSmartSendApi();
  const isPreManifest = useState(IsPreManifest(props.item));
  const { emit } = useEventEmitter<ManifestRefreshType>();
  const [error, setError] = useState('');
  const [state, setState] = useState<state>('IDLE');

  const reset = () => {
    setError('');
    setState('IDLE');
  };

  const cancel = () => {
    const rec = ExtendedOrderCache.preManifestedOrderLineIds.find((x) => x.SmartSendId === props.item.Id);
    if (rec) {
      const req: UpdateManifestApiModel = {
        ManifestOrderLinesToAdd: [],
        ManifestOrderLinesToRemove: [
          { CourierConsignmentId: '', OrderLineId: '', SmartSendId: rec.SmartSendId, IdsToManifest: [] }
        ],
        TriggerSubmission: false
      };

      setState('CANCELLING');

      updateManifest(rec.ProviderId, rec.AccountId, rec.ManifestId, req).then((r) => {
        if (r.success) {
          emit(Consts.ManifestRefresh, {});
          setState('SUCCESS');
        } else {
          const e = (r['error'] as any) || 'Unable to cancel label';
          setState('ERROR');
          setError(e);
        }

        setTimeout(reset, 5000);
      });
    }
  };

  if (!isPreManifest) {
    return null;
  }

  const view = (state: state) => {
    switch (state) {
      case 'SUCCESS':
      case 'CANCELLING':
        return <P2GText variant="body2">Cancelling...</P2GText>;
      case 'ERROR':
        return <AlertWithIcon color="error"> {error}</AlertWithIcon>;
      case 'IDLE':
        return (
          <DropConfirm initial={true} confirmText="Are you sure you want to cancel this label?" confirm={cancel} />
        );
    }
  };

  return (
    <P2GGrid item flexShrink={1}>
      <P2GContentDropDown
        onOpen={() => {}}
        control={
          <P2GLink>
            Cancel
            <br />
            Label
          </P2GLink>
        }
      >
        {view(state)}
      </P2GContentDropDown>
    </P2GGrid>
  );
}
